import { useCallback, useContext, useEffect, useState } from "react";
import BaseModel from "base/BaseModel";
import useWindowSize from "hooks/windowSizeHook";
import UserModel from "./userModel";
import GeneralModel from "./generalModel";
import { useServiceEndpointModel } from "./serviceEndpointModel";

const useAppUIModel = () => {
  // Region External Hooks

  const { width: windowWidth } = useWindowSize();
  const { t, navigate, errorHandler } = useContext(GeneralModel.Context);
  const { token, userData, organizationData, logout } = useContext(
    UserModel.Context,
  );

  const serviceEndpointModel = useServiceEndpointModel();

  // End Region

  // Region State, Memos, Refs

  const [menuWidth] = useState(300);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [showMenu, setShowMenu] = useState(!(windowWidth <= 980));
  const [isLoading, setIsLoading] = useState(false);
  const [currency, setCurrency] = useState(null);

  // End Region

  // Region Functions and Callbacks

  async function fetchCurrency() {
    try {
      const response = await serviceEndpointModel.getCurrencies();
      setCurrency(response?._id);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async function onLogout() {
    setIsLoading(true);
    try {
      await logout();
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  }

  const toggleMenu = useCallback((state) => {
    setShowMenu(state);
  }, []);

  // End Region

  // Region useEffect

  useEffect(() => {
    if (token) {
      fetchCurrency();
    }
  }, [token]);

  useEffect(() => {
    if (windowWidth <= 980) {
      toggleMenu(false);
    }
  }, [windowWidth]);

  // End Region

  return {
    t,
    navigate,
    userData,
    organizationData,

    windowWidth,
    menuWidth,
    headerHeight,
    setHeaderHeight,
    showMenu,
    setShowMenu,
    toggleMenu,
    isLoading,
    currency,

    onLogout,
  };
};

const AppUIModel = BaseModel(useAppUIModel, "AppUIModel");

export { useAppUIModel };
export default AppUIModel;
